import React from 'react';
import PropTypes from 'prop-types';
import './PageHeader.css';

/**
 * PageHeader - Reusable page header component with icon, title, and subtitle
 * Following the EvaluationList design pattern
 */
const PageHeader = ({ icon, title, subtitle, className = '' }) => {
    return (
        <div className={`page-header mb-4 ${className}`}>
            <h2 className="page-title">
                {icon && <i className={`bi bi-${icon} me-2`}></i>}
                {title}
            </h2>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
    );
};

PageHeader.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    className: PropTypes.string
};

export default PageHeader;